module.exports = __webpack_public_path__ + "static/WEDDING E&M-58-2018c3639719cffc95b7a6e8808e2a7a.jpg";